export const INSTRUMENT_TYPE = "sonic_prospect";

export const BOT_STATUS = {
  DRAFT: "draft",
  ACTIVE: "active",
  CLOSED: "closed",
};

export const WIZARD_STEPS = ["setup", "knowledge", "appearance", "embed"];

export const DEFAULT_BRAND_COLOR = "#7c3aed";

export const LAUNCHER_POSITIONS = [
  { value: "bottom-right", labelKey: "sonic_prospect.launcher_bottom_right" },
  { value: "bottom-left", labelKey: "sonic_prospect.launcher_bottom_left" },
];

export const DEFAULT_GOALS = {
  product_qa: true,
  lead_capture: true,
  handoff: false,
};

export const HANDOFF_DESTINATIONS = [
  { value: "sales_team", labelKey: "sonic_prospect.handoff_dest_sales" },
  { value: "hubspot", labelKey: "sonic_prospect.handoff_dest_hubspot" },
  { value: "email", labelKey: "sonic_prospect.handoff_dest_email" },
];

export const DEFAULT_HANDOFF = {
  enabled: false,
  availability: {
    enabled: true,
    days: ["mon", "tue", "wed", "thu", "fri"],
    start: "09:00",
    end: "18:00",
    timezone: "Europe/Istanbul",
  },
  triggers: {
    highPurchaseIntent: true,
    pricingQuestion: true,
    leadCaptured: true,
  },
  qualification: {
    requireLead: false,
    requireHighIntent: true,
  },
  routing: {
    destination: "sales_team",
    teamLabel: "Sales",
    email: "",
  },
  cannedReplies: [
    {
      id: "greeting",
      title: "Greeting",
      body: "Hi — I'm from Sales. Happy to help with pricing and next steps.",
    },
    {
      id: "pricing",
      title: "Pricing",
      body: "Happy to walk through pricing. How many seats are you evaluating, and what's your timeline?",
    },
    {
      id: "next_step",
      title: "Next step",
      body: "Great — I can send a short follow-up with options. What's the best email to use?",
    },
  ],
};


export const DEFAULT_BOT_DRAFT = {
  name: "",
  description: "",
  websiteUrl: "",
  language: "tr",
  greeting: "",
  goals: { ...DEFAULT_GOALS },
  appearance: {
    brandColor: DEFAULT_BRAND_COLOR,
    launcherPosition: "bottom-right",
    hideWatermark: false,
  },
  knowledge: {
    faqItems: [],
    pdfDocuments: [],
    websites: [],
    systemPrompt: "",
  },
  allowedDomains: [],
  instagram: {
    connected: false,
    igUserId: "",
    pageId: "",
  },
  handoff: {
    ...DEFAULT_HANDOFF,
    availability: { ...DEFAULT_HANDOFF.availability },
    triggers: { ...DEFAULT_HANDOFF.triggers },
    qualification: { ...DEFAULT_HANDOFF.qualification },
    routing: { ...DEFAULT_HANDOFF.routing },
    cannedReplies: [...DEFAULT_HANDOFF.cannedReplies],
  },
};

export const CHECKLIST_KEYS = ["named", "knowledge", "brand", "embed"];
